import React from "react";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const InvestmentPage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br px-6">
            {/* Icon */}
            <div className="bg-white p-6 rounded-full shadow-md mb-6">
                <HourglassEmptyIcon className="text-blue-500" sx={{ fontSize: 60 }} />
            </div>

            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
                Book Investments
            </h1>

            {/* Subtitle */}
            <p className="text-gray-600 text-center max-w-md mb-8">
                You do not have sufficient balance to invest, make more deposit for have access.
            </p>
        </div>
    );
};

export default InvestmentPage;
